import Component from './DeviceWorkOperatorMonitor.vue';

export default {
  install(Vue) {
    Vue.component('BkfDeviceWorkOperatorMonitor', Component);
  },
};
